<template>
<li :class="cls">
  <a :href="href" :class="detailClass">
    <span class="title semi-bold">{{ title }}</span>
    <span v-if="details.length > 0" class="details">{{ details }}</span>
  </a>
  <span :class="iconClass">
    <i v-if="thumbnail.length == 0" :class="icon"></i>
    <span v-if="thumbnail.length > 0">{{ thumbnail }}</span>
  </span>
</li>
</template>

<script>
  export default {
    name: "SidePanelItem",
    props: {
      href: {
        type: String,
        default: ''
      },
      title: {
        type: String,
        default: 'Item'
      },
      details: {
        type: String,
        default: ''
      },
      icon: {
        type: String,
        default: 'pg-home'
      },
      active: {
        type: Boolean,
        default: false
      },
      cls: {
        type: String,
        default: ''
      },
      thumbnail: {
        type: String,
        default: ''
      }
    },
    computed: {
      iconClass() {
        return this.active ? 'bg-success icon-thumbnail' : 'icon-thumbnail';
      },
      detailClass() {
        return this.details.length > 0 ? 'detailed' : 'no-details';
      }
    }
  }
</script>

<style>
    
</style>


// WEBPACK FOOTER //
// side_panel_item.vue?ed5d04e2